import React, { FunctionComponent, ReactNode } from 'react';
import { FullScreenWrapper } from 'components/Layouts/FullScreenView/FullScreenWrapper';
import { RecordingModel } from 'features/recordings/RecordingModel';

interface RecordingWrapperProps {
  children: ReactNode;
  recording: RecordingModel | null;
}

export const RecordingWrapper: FunctionComponent<RecordingWrapperProps> = ({
  children,
  recording
}) => {
  if (!recording) {
    return null;
  }

  return (
    <FullScreenWrapper
      artworkKey={recording.artworkKey}
      artworkMode={'recording'}
      type={'recording'}
    >
      {children}
    </FullScreenWrapper>
  );
};
